export const normalizeUrl = (value) => {
  const clean = (value || "").trim();
  if (!clean) return "";
  if (/^(https?:\/\/|mailto:|tel:|#|\/)/i.test(clean)) return clean;
  return `https://${clean}`;
};

export const normalizeSocialUrl = (value) => {
  const clean = (value || "").trim();
  if (!clean) return "";
  if (/^(https?:\/\/|mailto:|tel:|#|\/|@)/i.test(clean)) return clean;
  if (clean.includes(".") || clean.toLowerCase().startsWith("www.")) return normalizeUrl(clean);
  return clean;
};

export const normalizeUrlFields = (data, fields = ["website"], socialFields = ["instagram", "facebook", "tiktok"]) => {
  const next = { ...data };
  fields.forEach((field) => {
    if (next[field]) next[field] = normalizeUrl(next[field]);
  });
  socialFields.forEach((field) => {
    if (next[field]) next[field] = normalizeSocialUrl(next[field]);
  });
  return next;
};
